// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"62078b5e","453":"ababd16d","501":"2749ffb5"}[chunkId] + ".chunk.js";
};